var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"h2 mt-3 mb-5",domProps:{"textContent":_vm._s(_vm.$t('mail_request_completed.title'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('mail_request_completed.desc'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }